import { render, staticRenderFns } from "./CardRoleSearchBarComponent.vue?vue&type=template&id=47b547a1&scoped=true"
import script from "./CardRoleSearchBarComponent.vue?vue&type=script&lang=js"
export * from "./CardRoleSearchBarComponent.vue?vue&type=script&lang=js"
import style0 from "./CardRoleSearchBarComponent.vue?vue&type=style&index=0&id=47b547a1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b547a1",
  null
  
)

export default component.exports